import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-page',
  templateUrl: './share-page.component.html',
  styleUrls: ['./share-page.component.scss']
})
export class SharePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
